/* eslint-disable @typescript-eslint/camelcase */
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default {
  micro: [
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_1_KEY',
      stateKey: 'first_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'APPLICATION_SERVER_KEY',
      stateKey: 'first_period.application_server_mode',
      isSelect: true,
      options: [
        { value: 'active', label: 'ACTIVE_KEY' },
        { value: 'stopped', label: 'STOPPED_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVERS_KEY',
      stateKey: 'first_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_2_KEY',
      stateKey: 'second_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'APPLICATION_SERVER_KEY',
      stateKey: 'second_period.application_server_mode',
      isSelect: true,
      options: [
        { value: 'active', label: 'ACTIVE_KEY' },
        { value: 'stopped', label: 'STOPPED_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVERS_KEY',
      stateKey: 'second_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
  ],
  period: [
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_1_KEY',
      stateKey: 'first_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_KEY',
      stateKey: 'first_period.scale_instances_by_licences_margin',
      isSelect: true,
      options: [
        { value: 'true', label: 'TURNED_ON_KEY' },
        { value: 'false', label: 'OFF_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_PERCENT_KEY',
      stateKey: 'first_period.licences_margin_percent',
      type: 'number',
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVER_KEY',
      stateKey: 'first_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },

    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_2_KEY',
      stateKey: 'second_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_KEY',
      stateKey: 'second_period.scale_instances_by_licences_margin',
      isSelect: true,
      options: [
        { value: 'true', label: 'TURNED_ON_KEY' },
        { value: 'false', label: 'OFF_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_PERCENT_KEY',
      stateKey: 'second_period.licences_margin_percent',
      type: 'number',
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVER_KEY',
      stateKey: 'second_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
  ],
  spot_period: [
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_1_KEY',
      stateKey: 'first_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_KEY',
      stateKey: 'first_period.scale_instances_by_licences_margin',
      isSelect: true,
      options: [
        { value: 'true', label: 'TURNED_ON_KEY' },
        { value: 'false', label: 'OFF_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_PERCENT_KEY',
      stateKey: 'first_period.licences_margin_percent',
      type: 'number',
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVER_KEY',
      stateKey: 'first_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },

    {
      gridXs: 12,
      validateOnChange: true,
      label: 'PERIOD_2_KEY',
      stateKey: 'second_period.is_active',
      isCheckbox: true,
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_KEY',
      stateKey: 'second_period.scale_instances_by_licences_margin',
      isSelect: true,
      options: [
        { value: 'true', label: 'TURNED_ON_KEY' },
        { value: 'false', label: 'OFF_KEY' },
      ],
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'MARGIN_PERCENT_KEY',
      stateKey: 'second_period.licences_margin_percent',
      type: 'number',
    },
    {
      gridXs: 12,
      validateOnChange: true,
      label: 'SUPPORT_SERVER_KEY',
      stateKey: 'second_period.keep_support_servers',
      isSelect: true,
      options: [
        { value: 'activated', label: 'ACTIVE_BEHAVIOR_KEY' },
        { value: 'stopped', label: 'STOPPED_BEHAVIOR_KEY' },
        { value: 'on_demand', label: 'ON_DEMAND_BEHAVIOR_KEY' },
      ],
    },
  ],
} as Record<string, GenericFormItem[]>;
